import { openBlock as t, createElementBlock as i, renderSlot as o, pushScopeId as r, popScopeId as s, createElementVNode as d } from "vue";
import { _ as l } from "./chunks/_plugin-vue_export-helper.CHgC5LLL.js";
import './assets/BaseShimmerLoader.css';const a = {}, c = (e) => (r("data-v-22144f1b"), e = e(), s(), e), u = { class: "uikit-relative uikit-overflow-hidden uikit-bg-w-lavender" }, n = /* @__PURE__ */ c(() => /* @__PURE__ */ d("div", { class: "shimmer uikit-absolute uikit-bottom-0 uikit-left-0 uikit-right-0 uikit-top-0 uikit-h-full -uikit-translate-x-full" }, null, -1));
function f(e, _) {
  return t(), i("div", u, [
    n,
    o(e.$slots, "default", {}, void 0, !0)
  ]);
}
const m = /* @__PURE__ */ l(a, [["render", f], ["__scopeId", "data-v-22144f1b"]]);
export {
  m as default
};
